/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllOktaUserList } from './oktaAction';
  
const initialState = {
    data: {},
    oktaUsers: {}
}
const oktaSlice = createSlice({
    name: 'okta',
    initialState,
    extraReducers: {
        [getAllOktaUserList.fulfilled]: (state, { payload }) => {
            state.oktaUsers = payload;
        },
    }
});

export default oktaSlice.reducer;